import { lazy } from "react";

const ProtectedRoutes = [
  {
    Component: lazy(() => import("./pages/mylearning/myLearning")),
    path: "/mylearning",
  },
  {
    Component: lazy(() => import("./pages/logros")),
    path: "/logros",
  },
  {
    Component: lazy(() => import("./pages/myShopping/myShopping")),
    path: "/myshopping",
  },
  {
    Component: lazy(() => import("./pages/myShopping/myShoppingDetail")),
    path: "/myshopping-detail/:id",
  },
  {
    Component: lazy(() => import("./pages/profile")),
    path: "/profile",
  },
  {
    Component: lazy(() => import("./pages/plans")),
    path: "/plans",
  },
  {
    Component: lazy(() => import("./pages/membership")),
    path: "/membership",
  },
  {
    Component: lazy(() => import("./pages/courses/courses")),
    path: "/courses",
  },
  {
    Component: lazy(() => import("./pages/courses/course-exam-info")),
    path: "/course-exam-info/:id",
  },
  {
    Component: lazy(() => import("./pages/courses/course-exam")),
    path: "/course-exam/:id",
  },
  {
    Component: lazy(() => import("./pages/courses/course-generate")),
    path: "/course-generate",
  },
  {
    Component: lazy(() => import("./pages/contact-1")),
    path: "/contact-1",
  },
  {
    Component: lazy(() => import("./pages/courses/courses-details")),
    path: "/courses-details/:id",
  },
  {
    Component: lazy(() => import("./pages/courses/course-tracking")),
    path: "/course-tracking/:id",
  },
  {
    Component: lazy(() => import("./pages/courses/course-tracking")),
    path: "/course-tracking/:course/:topic/:id",
  },
  {
    Component: lazy(() => import("./pages/courses/course-tracking")),
    path: "/course-tracking/:course/:topic/:subtopic/:id",
  },
  {
    Component: lazy(() => import("./pages/courses/course-exam-info")),
    path: "/course-certificate/:id",
  },
  {
    Component: lazy(() => import("./pages/purchase-detail")),
    path: "/purchase-detail",
  },
  {
    Component: lazy(() => import("./pages/purchase")),
    path: "/purchase",
  },
  {
    Component: lazy(() => import("./pages/books")),
    path: "/books",
  },
  {
    Component: lazy(() => import("./pages/courses/course-result")),
    path: "/course-result",
  },
  /*{
    Component: lazy(() => import("./pages/error-404")),
    path: "/*",
  },*/
];

export default ProtectedRoutes;
